import { createSlice } from '@reduxjs/toolkit';

/**
 * ErrorDialog 상태 관리 (전역 상태)
 * - open: 다이얼로그 열림 여부
 * - title: 다이얼로그 제목
 * - message: 에러 메시지
 * - type: 에러 타입 ('auth' | 'error' | 'warning')
 * - showLoginButton: 로그인 버튼 표시 여부
 *
 * 사용 예시:
 * dispatch(showErrorDialog({
 *   title: '세션 만료',
 *   message: '로그인이 필요합니다.',
 *   type: 'auth',
 *   showLoginButton: true
 * }));
 * dispatch(closeErrorDialog());
 */

const initialState = {
  open: false,
  title: '오류 발생',
  message: '오류가 발생했습니다.',
  type: 'error', // 'auth' | 'error' | 'warning'
  showLoginButton: false,
};

const ErrorDialogSlice = createSlice({
  name: 'ErrorDialog',
  initialState,
  reducers: {
    showErrorDialog: (state, action) => {
      const {
        title = '오류 발생',
        message = '오류가 발생했습니다.',
        type = 'error',
        showLoginButton = false,
      } = action.payload || {};
      state.open = true;
      state.title = title;
      state.message = message;
      state.type = type;
      state.showLoginButton = showLoginButton;
    },
    closeErrorDialog: (state) => {
      state.open = false;
      state.title = '오류 발생';
      state.message = '오류가 발생했습니다.';
      state.type = 'error';
      state.showLoginButton = false;
    },
  },
});

export const { showErrorDialog, closeErrorDialog } = ErrorDialogSlice.actions;
export default ErrorDialogSlice.reducer;
